var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{class:_vm.$vuetify.breakpoint.mdAndDown ? 'py-2' : 'py-4'},[_c('span',{staticClass:"text-h4 font-weight-bold"},[_vm._t("default")],2),_c('div',{staticClass:"text-body-2"},[_vm._t("subtitle")],2)]),_c('v-spacer'),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }